<div class="popup modal-header w-100 d-inline-block  pb-0 mb-0">
   
    <div >
      <div class="d-flex justify-content-between align-items-center header">
        <p >Modify Booking</p>
        <div class="text-right" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
      </div>
      
      <p class="title text-left"> What do you want to amend? </p>

      <div class="d-flex justify-content-between align-items-center date my-3 " (click)="onEditDate()">
          <p>Change Dates and Guests</p>
          <fa-icon [icon]="icons.chevronRight" class="icon"></fa-icon>
      </div>
      <div class="d-flex justify-content-between align-items-center contact my-3 " (click)="onEditContact()">
          <p class="pb-0">Change Contact Details</p>
          <fa-icon [icon]="icons.chevronRight" class="icon"></fa-icon>
      </div>
      
    </div>
  </div>
  